/*
 * @Author: hai.yang3 hai.yang3@gientech.com
 * @Date: 2022-08-20 11:25:59
 * @LastEditors: chenming
 * @LastEditTime: 2022-12-15 18:19:27
 * @FilePath: \unified-development-platform\src\apis\auth\move-auth\app\menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request } from '@/apis/request';

const PRE_PATH = '/v1/app';

// 菜单管理 —— 获取菜单按钮列表
export const getMenusButtons = params => {
  return request({
    url: `${PRE_PATH}/menu/list`,
    method: 'get',
    params: params,
    rd: true,
  });
};

// export const getMenusButtons = params => {
//   return request({
//     url: `${PRE_PATH}/menu`,
//     method: 'get',
//     params: params,
//     rd: true,
//   });
// };
//  获取用户的菜单权限
export const getMenusButtonsByRole = () => {
  return request({
    url: `${PRE_PATH}/appUser/menus`,
    method: 'get',
    rd: true,
  });
};

// 菜单管理 —— 按钮删除
export function deleteButton(buttonNo, appId) {
  return request({
    url: `${PRE_PATH}/button/delete?buttonNo=${buttonNo}&appId=${appId}`,
    method: 'delete',
    rd: true,
  });
}

// 菜单管理 —— 删除菜单
export function deleteMenu(menuNo, appId) {
  return request({
    url: `${PRE_PATH}/menu/delete?appId=${appId}&menuNo=${menuNo}`,
    method: 'delete',
    rd: true,
  });
}
// export function deleteMenu(menuNo, appId) {
//   return request({
//     url: `${PRE_PATH}/menu/${menuNo}/${appId}`,
//     method: 'delete',
//     rd: true,
//   });
// }

// 菜单管理 —— 修改按钮
export function updateButton(data) {
  return request({
    url: `${PRE_PATH}/button/update`,
    method: 'post',
    data: data,
    rd: true,
  });
}

// 菜单管理 —— 判断序号是否已经存在
export function checkMenuOrder(data) {
  return request({
    url: `${PRE_PATH}/menu/order`,
    method: 'post',
    data: data,
    rd: true,
  });
}

// 菜单管理 —— 修改
export function updateMenu(data) {
  return request({
    url: `${PRE_PATH}/menu/update`,
    method: 'post',
    data: data,
    rd: true,
  });
}
// 菜单管理 —— 判断菜单code是否已经存在
export const checkMenuCode = (data, hideLoading = false) => {
  return request({
    url: `${PRE_PATH}/menu/code`,
    method: 'post',
    data: data,
    rd: true,
    hideLoading,
  });
};

// 菜单管理 —— 判断菜单名称是否已经存在
export const checkMenuName = data => {
  return request({
    url: `${PRE_PATH}/menu/name`,
    method: 'post',
    data: data,
    rd: true,
  });
};

// 菜单管理 —— 判断按钮code是否已经存在
export const checkButtonCode = data => {
  return request({
    url: `${PRE_PATH}/button/code`,
    method: 'post',
    data: data,
    rd: true,
  });
};
// 菜单管理 —— 判断按钮名称是否已经存在
export const checkButtonName = data => {
  return request({
    url: `${PRE_PATH}/button/name`,
    method: 'post',
    data: data,
    rd: true,
  });
};

// 菜单管理 —— 获取当前菜单下子菜单的最大排序号
export const getMaxOrder = params => {
  return request({
    url: `${PRE_PATH}/menu/maxMenuOrder`,
    method: 'get',
    params: params,
    rd: true,
  });
};
// 菜单管理 —— 新增
export const addMenu = data => {
  return request({
    url: `${PRE_PATH}/menu/add`,
    method: 'post',
    data: data,
    rd: true,
  });
};
// export const addMenu = (data) => {
//   return request({
//     url: `${PRE_PATH}/menu`,
//     method: 'post',
//     data: data,
//     rd: true
//   })
// }
export const addButton = data => {
  return request({
    url: `${PRE_PATH}/button/add`,
    method: 'post',
    data: data,
    rd: true,
  });
};

// 菜单管理 —— 创建角色时，关联菜单时获取所有菜单
export const getRoleMenusButtons = (rolePlatformNo, appId) => {
  return request({
    url: `${PRE_PATH}/menu/roleMenuAndButtons?rolePlatformNo=${rolePlatformNo}&appId=${appId}`,
    method: 'get',
    rd: true,
  });
};
